// initial state
import * as base from './base.js'
const baseName = '/admin/system/desk'

const offices = baseName + '/list'

const obj = base.setBaseUrl('offices', baseName)

const a = Object.assign(obj,{offices})
export default a
